<template>
  <div>
    <MainHeader />
    <v-container>
      <v-row>
        <v-col
          class="mt-4"
          cols="12"
        >
          <CardTransactionsSummary
            class="mt-4"
            :loading="transactionsLoaded"
            :summary-data="transactionsData"
            :license="$route.params.license"
            @page-loading="onPageLoading"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          class="mt-4"
          cols="12"
        >
          <CardWalletsSummary
            :loading="walletsLoaded"
            :summary-data="walletsData"
            :license="$route.params.license"
            @page-loading="onPageLoading"
          />
        </v-col>
      </v-row>

      <v-overlay :value="pageLoading">
        <VProgressCircular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import SafeguardingService from "@/services/SafeguardingService";
import CardTransactionsSummary from "@/components/safeguarding/CardTransactionsSummary";
import CardWalletsSummary from "@/components/safeguarding/CardWalletsSummary";

export default {
  name: "Safeguarding",
  components: {
    MainHeader,
    CardTransactionsSummary,
    CardWalletsSummary
  },
  data() {
    return {
      transactionsLoaded: false,
      transactionsData: [],
      walletsLoaded: false,
      walletsData: null,
      pageLoading: false
    };
  },
  mounted() {
    this.getTransactionsSummary();
    this.getWalletsSummary();
  },
  methods: {
    onPageLoading(value) {
      this.pageLoading = value;
    },
    getTransactionsSummary() {
      this.transactionsLoaded = true;

      SafeguardingService.getTransactionsSummary({
        license: this.$route.params.license
      })
        .then(res => {
          this.transactionsData = res.data;
        })
        .finally(() => {
          this.transactionsLoaded = false;
        });
    },
    getWalletsSummary() {
      this.walletsLoaded = true;

      SafeguardingService.getWalletsSummary({
        license: this.$route.params.license
      })
        .then(res => {
          this.walletsData = res.data;
        })
        .finally(() => {
          this.walletsLoaded = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
